import { BarIcon, BoxplotIcon } from "@/components/icons/custom-chart-icons"
import { summaryStore } from "../summary-store"

const ChartController = () => {
  const { chartSwitch, toggleChartSwitch } = summaryStore()

  return (
    <div className="flex gap-1 bg-gray-100/80 rounded-lg py-1 px-1.5">
      <button
        className={`flex items-center justify-center p-1 rounded-lg cursor-pointer border aspect-square
          
        ${chartSwitch.bar ? "bg-white border-gray-200 shadow-sm" : "border-transparent"}
      `}
        onClick={() => toggleChartSwitch("bar")}
      >
        <BarIcon />
      </button>
      <button
        className={`flex items-center justify-center p-1 rounded-lg cursor-pointer border aspect-square
        
        ${chartSwitch.boxplot ? "bg-white border-gray-200 shadow-sm" : "border-transparent"}
        `}
        onClick={() => toggleChartSwitch("boxplot")}
      >
        <BoxplotIcon />
      </button>
    </div>
  )
}

export default ChartController
